export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? 'brand-compact' : ''}`}>
      <svg aria-hidden="true" viewBox="0 0 32 32" fill="none">
        <path
          d="M5 21V11M12 26V6M19 22V10M26 18V14"
          stroke="currentColor"
          strokeWidth="3.5"
          strokeLinecap="round"
        />
      </svg>
      <span>Salary Management</span>
    </div>
  )
}

const paths = {
  dashboard: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
  people:
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3a4 4 0 0 1 0 8M22 21v-2a4 4 0 0 0-3-3.87M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
  bands: 'M4 5h16M4 12h16M4 19h16M8 2v6M16 9v6M11 16v6',
  equity: 'M12 3v18M4 21h16M3 7h18M6 7l-4 7h8L6 7ZM18 7l-4 7h8l-4-7Z',
  round: 'M4 4h16v16H4zM4 10h16M10 4v16M14 15h3M15.5 13.5v3',
  import: 'M12 16V3M7 8l5-5 5 5M4 14v7h16v-7',
  audit: 'M8 3h12v18H4V7M8 3v4H4M8 12h8M8 16h8',
  logout: 'M9 4H3v16h6M10 12h11M17 8l4 4-4 4',
  arrow: 'M5 12h14M13 6l6 6-6 6',
  calendar: 'M4 5h16v16H4zM8 3v4M16 3v4M4 10h16',
  check: 'M5 12l4 4L19 6',
  eye: 'M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
  plus: 'M12 5v14M5 12h14',
} as const

export function Icon({ name, className = '' }: { name: keyof typeof paths; className?: string }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`size-[18px] shrink-0 ${className}`}
    >
      <path d={paths[name]} />
    </svg>
  )
}

export function Avatar({
  firstName,
  lastName,
  large = false,
}: {
  firstName: string
  lastName: string
  large?: boolean
}) {
  return (
    <span aria-hidden="true" className={`person-avatar ${large ? 'person-avatar-large' : ''}`}>
      {firstName.slice(0, 1)}
      {lastName.slice(0, 1)}
    </span>
  )
}
